<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="moduleForm">
		<p-tabView [scrollable]="true">
			<!----------TAB SETTTINGS ------------->
			<p-tabPanel header="{{ 'SETTINGS' | translate }}">
				<!-- NOME * -->
				<div class="grid">
					<div class="col-12">
						<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.Name, 'borderRow')">
							<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.Name, 'label')">{{ 'NAME' | translate }}</div>
							<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.Name, 'borderInput')">
							<input type="text" pInputText
								[ngClass]="dynamicInputTextWidth()"
								formControlName="Name"
								autocomplete="module-name"
								placeholder="{{ 'NAME' | translate }}"
								maxlength="48"
							/>
							</div>
						</div>
						<small *ngIf="showErrorRequiredMessage(this.f.Name)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
					</div>
			</div>
			<!-- FIRMWARE * -->
			<div class="grid">
					<div class="col-12 text-sm flex justify-content-start align-items-center flex-wrap">
						<div class="">{{'FWVersion' | translate }}: {{module.FWVersion}}</div>
					</div>
					<div class="col-12 text-sm flex justify-content-start align-items-center flex-wrap">
						<div class="">{{'FWVersionBL' | translate }}: {{module.FWVersionBL}}</div>
					</div>
				</div>
				<!-- SETTINGS * -->
				<div class="grid">
					<div class="col-12">
						<h2>{{ 'SETTINGS' | translate }}</h2>
					</div>
				</div>
				<div *ngFor="let setting of mtmacConfig; let i=index;" [class]="underTablet() && checkNotEmptyRow(setting) ? 'col-12' : ''">
					<div *ngIf="setting.Value !== null && checkNotEmptyRow(setting)"
					[class]="underTablet() ? 'grid mt-1' : 'col-12 flex align-items-center justify-content-between'">
						<ng-container>
							<div *ngIf="setting.Type === 'int'" [class]="underTablet() ? 'col-12 pt-0 flex align-items-center justify-content-center text-center' : 'col-6 pl-0 flex align-items-center justify-content-start text-start' ">{{ getTranslate(setting.Name, true) }}</div>
							<div *ngIf="setting.Type === 'int'" [class]="underTablet() ? 'col-12 pt-0' : 'col-6 px-0 py-1' " class="flex align-items-center justify-content-center">
								<div class="flex align-items-center justify-content-center w-full">
									<p-button pTooltip="{{ 'DECREASE' | translate }}"
											[disabled]="isSliderMin(setting)"
											tooltipPosition="bottom" icon="pi cm-minus" size="large"
											(click)="setSliderValue(setting, -1)" [rounded]="false" [text]="true" severity="primary"
											class="pr-3">
									</p-button>
									<div>{{formattedSliderMin(setting)}}</div>
		
									<div class="flex flex-column w-full mx-4"> <!-- !! TO CHECK IF VARIANT=FILLED IS OK (punto al posto della virgola)-->
										<p-inputNumber mode="decimal" [useGrouping]="false" variant="filled"
												[formControlName]="setting.Name" 
												class="flex w-full"
												styleClass="flex w-full"
												[min]="setting.Min"
												[max]="setting.Max"
												(onBlur)="onChangeInputSlider(setting)">
										</p-inputNumber>
										<p-slider [formControlName]="setting.Name" class="w-full" [step]="setting.StepSize"
												[min]="setting.Min"
												[max]="setting.Max"
												(onChange)="onChangeSlider(setting)">
										</p-slider>
									</div>
										
									<div>{{ formattedSliderMax(setting) }}</div>
									<p-button pTooltip="{{ 'INCREASE' | translate}}"
												[disabled]="isSliderMax(setting)"
												tooltipPosition="bottom" icon="pi cm-plus" size="large"
												(click)="setSliderValue(setting, 1)" [rounded]="false" [text]="true" severity="primary"
												class="pl-3">
									</p-button>
									<!--OLD-->
									<!--<p-button pTooltip="{{ 'DECREASE' | translate }}"
											[disabled]="isSliderMin(setting)"
											tooltipPosition="bottom" icon="pi cm-minus" size="large"
											(click)="setSliderDecreaseValue(setting)" [rounded]="false" [text]="true" severity="primary"
											class="pr-3">
									</p-button>
									<div>{{setting.Min}}</div>

									<div class="flex flex-column w-full mx-4">
										<p-inputNumber mode="decimal"  [useGrouping]="false"
												[formControlName]="setting.Name"
												class="flex w-full"
												styleClass="flex w-full"
												[min]="setting.Min"
												[max]="setting.Max"
												(onBlur)="onChangeInputSlider(setting)">
										</p-inputNumber>
										<p-slider [formControlName]="setting.Name" class="w-full" [step]="setting.StepSize"
												[min]="setting.Min"
												[max]="setting.Max"
												(onChange)="onChangeSlider(setting)">
										</p-slider>
									</div>
										
									<div>{{setting.Max}}</div>
									<p-button pTooltip="{{ 'INCREASE' | translate}}"
												[disabled]="isSliderMax(setting)"
												tooltipPosition="bottom" icon="pi cm-plus" size="large"
												(click)="setSliderIncreaseValue(setting)" [rounded]="false" [text]="true" severity="primary"
												class="pl-3">
									</p-button>-->
								</div>
							</div>
							<!-- !! TO CHECK LAYOUT AND FEATURE -->
							<div *ngIf="setting.Type === 'numeric'">
								<div class="flex justify-content-between flex-wrap" >
									<div class="flex align-items-center justify-content-center">{{ 'DEFINE_DELAY_TIME' | translate }} *</div>
									<div class="flex align-items-center justify-content-center">
										<p-inputNumber [formControlName]="setting.Id" step="1" [useGrouping]="false" [maxFractionDigits]="0" [showButtons]="true"
												incrementButtonClass="p-0" decrementButtonClass="p-0 border-noround"
												[max]="setting.Max"
												[min]="setting.Min">
										</p-inputNumber>
									</div>
								</div>
							</div>
							<div *ngIf="setting.Type === 'intset'" class="col-12 p-0">
									<div class="flex justify-content-between flex-wrap border-bottom-1 border-100" [ngClass]="dynamicBorderLabelMobile('borderRow')">
										<div class="flex align-items-center justify-content-center" [ngClass]="dynamicBorderLabelMobile('label')">{{ getTranslate(setting.Name, true) }}</div>
										<div class="flex align-items-center justify-content-center" [ngClass]="dynamicBorderLabelMobile('borderInput')">
											<p-dropdown [options]="setting.Values"
												[ngClass]="dynamicInputTextWidth()" appendTo="body"
												styleClass="{{ dynamicInputTextWidth() }} align-items-center text-center"
												[formControlName]="setting.Name">
												<ng-template pTemplate="selectedItem">
													<div class="item" class="flex align-items-center justify-content-center text-center pl-5">
														<div class="flex align-items-center">{{ (f[setting.Name]) ? getTranslate(f[setting.Name].value.Label, false) : "" }}</div>
													</div>
												</ng-template>
												<ng-template let-controlItem pTemplate="item">
													<div class="item">
														<div>{{ getTranslate(controlItem.Label, false)}}</div>
													</div>
												</ng-template>
											</p-dropdown>
										</div>
									</div>
									<!-- NO VALIDATOR HERE -> SET DEFAULT VALUE FOR DROPDOWN AND REMOVE 'small' MESSAGE -->
									<!-- <small *ngIf="showErrorRequiredMessage(this.f.settingValue)" class="flex align-items-center label-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small> -->
							</div>
							<div *ngIf="setting.Type === 'bool'" class="col-12 p-0">
									<div class="flex justify-content-between flex-wrap border-bottom-1 border-100" [ngClass]="dynamicBorderLabelMobile('borderRow')">
										<div class="flex align-items-center justify-content-center" [ngClass]="dynamicBorderLabelMobile('label')">{{ getTranslate(setting.Name, true) }}</div>
										<div class="flex align-items-center justify-content-center" [ngClass]="dynamicBorderLabelMobile('borderInput')">
											<p-dropdown [options]="setting.Values"
												[ngClass]="dynamicInputTextWidth()" appendTo="body"
												styleClass="{{ dynamicInputTextWidth() }} align-items-center text-center"
												[formControlName]="setting.Name">
												<ng-template pTemplate="selectedItem">
													<div class="item" class="flex align-items-center justify-content-center text-center pl-5">
														<div class="flex align-items-center">{{ (f[setting.Name]) ? getTranslate(f[setting.Name].value.Label, false) : "" }}</div>
													</div>
												</ng-template>
												<ng-template let-controlItem pTemplate="item">
													<div class="item">
														<div>{{ getTranslate(controlItem.Label, false)}}</div>
													</div>
												</ng-template>
											</p-dropdown>
										</div>
									</div>
									<!-- NO VALIDATOR HERE -> SET DEFAULT VALUE FOR DROPDOWN AND REMOVE 'small' MESSAGE -->
									<!-- <small *ngIf="showErrorRequiredMessage(this.f.settingValue)" class="flex align-items-center label-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small> -->
							</div>
							<div *ngIf="setting.Type === 'str'" class="col-12 p-0">
									<div class="flex justify-content-between flex-wrap" [ngClass]="dynamicBorderLabelMobile('borderRow')">
										<div class="flex align-items-center justify-content-center" [ngClass]="dynamicBorderLabelMobile('label')">{{ setting.Name }}*</div>
										<div class="flex align-items-center justify-content-center" [ngClass]="dynamicBorderLabelMobile('borderInput')">
											<input type="text" pInputText
												[ngClass]="dynamicInputTextWidth()"
												[formControlName]="setting.Name"
												placeholder="{{ setting.Name }}"
												maxlength="{{setting.Max}}"
											/>
										</div>
									</div>
									<!-- NO VALIDATOR HERE -> SET DEFAULT VALUE FOR DROPDOWN AND REMOVE 'small' MESSAGE -->
									<!-- <small *ngIf="showErrorRequiredMessage(this.f.settingValue)" class="flex align-items-center label-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small> -->
							</div>
							<div *ngIf="setting.Type === 'tzlist'" class="col-12 p-0">
									<div class="flex justify-content-between flex-wrap border-bottom-1 border-100" [ngClass]="dynamicBorderLabelMobile('borderRow')">
										<div class="flex align-items-center justify-content-center" [ngClass]="dynamicBorderLabelMobile('label')">{{ getTranslate(setting.Name, true) }}</div>
										<div class="flex align-items-center justify-content-center" [ngClass]="dynamicBorderLabelMobile('borderInput')">
											<p-dropdown [options]="timezones"
												[ngClass]="dynamicInputTextWidth()" appendTo="body"
												styleClass="{{ dynamicInputTextWidth() }} align-items-center text-center"
												[formControlName]="setting.Name">
												<ng-template pTemplate="selectedItem">
													<div class="item" class="flex align-items-center justify-content-center text-center pl-5">
														<div class="flex align-items-center">{{ (f[setting.Name]) ? f[setting.Name].value : "" }}</div>
													</div>
												</ng-template>
												<ng-template let-controlItem pTemplate="item">
													<div class="item">
														<div>{{ controlItem}}</div>
													</div>
												</ng-template>
											</p-dropdown>
										</div>
									</div>
									<!-- NO VALIDATOR HERE -> SET DEFAULT VALUE FOR DROPDOWN AND REMOVE 'small' MESSAGE -->
									<!-- <small *ngIf="showErrorRequiredMessage(this.f.settingValue)" class="flex align-items-center label-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small> -->
							</div>
						</ng-container>
					</div>
				</div>
			</p-tabPanel>
			<!----------CUSTOM MESSAGE | Lingua personalizzata ------------->
			<p-tabPanel header="{{ 'MTMA_CONF_Messages' | translate }}">
				<div *ngIf="saving">
					<div class="flex align-items-center justify-content-center w-full pb-8 mb-8">
						<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
					</div>
				</div>
				<div *ngFor="let setting of mtmacConfig; let i=index;">
					<div *ngIf="setting.Type === 'strmap' && !saving">
						<ng-container>
							<div *ngIf="setting.Type === 'strmap'">
								<div *ngFor="let map of setting.Values" class="col-12">
									<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(setting.Name+'_'+map.Name,'borderRow')" *ngIf="!map.Name.includes('Row')">
										<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(setting.Name+'_'+map.Name,'label')">{{ getTranslate(map.Label, true) }}</div>
										<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(setting.Name+'_'+map.Name,'borderInput')">
											<input type="text" pInputText
												[ngClass]="dynamicInputTextWidth()"
												[formControlName]="setting.Name+'_'+map.Name"
												placeholder="{{ getTranslate(map.Label, true) }}"
												maxlength="32"
											/>
										</div>
									</div>
									<div class="flex justify-content-between flex-wrap border-100 border-bottom-1" [ngClass]="dynamicBorderLabelMobile('borderRow')" *ngIf="map.Name.includes('Row')">
										<div class="flex align-items-center justify-content-center" [ngClass]="dynamicBorderLabelMobile('label')">{{ getTranslate(map.Label, true) }}</div>
										<div class="flex align-items-center justify-content-center" [ngClass]="dynamicBorderLabelMobile('borderInput')">
											<input type="text" pInputText
												[ngClass]="dynamicInputTextWidth()"
												[formControlName]="setting.Name+'_'+map.Name"
												placeholder="{{ getTranslate(map.Label, true) }}"
												maxlength="32"
											/>
										</div>
									</div>
									<small *ngIf="!map.Name.includes('Row') && showErrorRequiredMessage(setting.Name+'_'+map.Name)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</p-tabPanel>
			<!----------WELCOME MESSAGE | Messaggi di benvenuto ------------->
			<p-tabPanel header="{{ 'MTMA_CONF_WelcomeMsg' | translate }}">
				<div *ngFor="let setting of mtmacConfig">
					<div *ngIf="setting.Type === 'strset'">
						<ng-container>
							<div *ngIf="setting.Type === 'strset'">
								<div *ngFor="let map of setting.List; index as i" class="col-12">
									<div *ngIf="i==0 || i==4 || i==8 || i==12" class="flex justify-content-center font-semibold pb-3">
										{{'MTMA_PAGE' | translate}} {{getPage(i)}}
									</div>
									<div class="flex justify-content-between flex-wrap border-100 border-bottom-1" [ngClass]="dynamicBorderLabelMobile('borderRow')">
										<div class="flex align-items-center justify-content-center" [ngClass]="dynamicBorderLabelMobile('label')">{{'MTMA_ROW' | translate}} {{getRow(i)}}</div>
										<div class="flex align-items-center justify-content-center" [ngClass]="dynamicBorderLabelMobile('borderInput')">
											<input type="text" pInputText
												[ngClass]="dynamicInputTextDesktopTabletWidth()"
												[formControlName]="setting.Name+'_'+i"
												placeholder="{{'MTMA_ROW' | translate}} {{getRow(i)}}"
												maxlength="64"
											/>
										</div>
									</div>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</p-tabPanel>
		</p-tabView>

		<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple
				label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mt-2 mx-1"
				[ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()"
					label="{{ 'CANCEL' | translate }}"
					class="p-button-secondary text-xl font-normal mt-2 mx-1"
					[ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>
	